import * as Utils from 'Assets/Utils'
import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import {createModal} from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({})
	.set('Search', new Immutable.List([]))
	.set('Response', new Immutable.Map({}))
	.set('Get', new Immutable.Map({}));

/* Types */
export const ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS = 'ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS';
export const ACTION_GET_PAYMENT_REQUIREMENT_STATUS = 'ACTION_GET_PAYMENT_REQUIREMENT_STATUS';
export const ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS = 'ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS';
export const ACTION_UPDATE_PAYMENT_REQUIREMENT_STATUS = 'ACTION_UPDATE_PAYMENT_REQUIREMENT_STATUS';

/* Reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS:
			return state.set('Search', new Immutable.List(action.Obj));
		case ACTION_GET_PAYMENT_REQUIREMENT_STATUS:
			return state.set('Get', new Immutable.Map(action.Obj));
		case ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS:
			return state.set('Response', new Immutable.Map(action.Obj));
		case ACTION_UPDATE_PAYMENT_REQUIREMENT_STATUS:
			return state.set('Response', new Immutable.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */
export const addPaymentRequirement = (form) => {

	let temp = {
		id: form.id ? parseInt(form.id) : null,
		deleted: form.state === 1 ? false : form.state === 2 ? true : null,
		requisitoPago: form.requisitoPago || "",
		detalle: form.detalleRequisitoPago || "",
		tipoRequisitoPago: {
			id: form.tiposPago || null
		},
		createdBy: sessionStorage.uid
	}

	return (dispatch) => {
		dispatch(isLoading(true));
		return new ClientHttpRequest({
			service: temp.id ? 'api/updatePaymentRequirement' : 'api/newPaymentRequirement',
			method: "POST",
			data: {...temp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(() => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		});
	}
};

export const searchPaymentRequirement = (form) => {
	Utils.clearNullAndEmpty(form);

	let temp = {
		deleted: form.state === 1 ? false : form.state === 2 ? true : null,
		id: form.id ? parseInt(form.id) : null,
		requisitoPago: form.requisitoPago || "",
		tipoRequisitoPago: {
			id: form.tiposPago || null
		}
	}

	return (dispatch) => {
		dispatch(isLoading(true));
		return new ClientHttpRequest({
			service: Object.keys(form).length === 0 ? 'api/searchPaymentRequirement' : 'api/searchParamPaymentRequirement',
			method: "POST",
			data: {...temp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({type: ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS, Obj: response.data})
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		});
	}
};

export const getPaymentRequirement = (id) => {
	return (dispatch) => {
		dispatch(isLoading(true));
		return new ClientHttpRequest({
			service: 'api/getPaymentRequirement',
			method: "POST",
			data: {id},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {

			const data = response.data

			let obj = {
				uniqueId: Utils.getUUID(),
				id: data.id,
				state: data.deleted === false ? 1 : 2,
				requisitoPago: data.requisitoPago,
				tiposPago: data.tipoRequisitoPago.id,
				detalleRequisitoPago: data.detalle
			}

			dispatch({type: ACTION_GET_PAYMENT_REQUIREMENT_STATUS, Obj: obj})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		});
	}
};

export const deletePaymentRequirement = () => {
	return (dispatch) => {
		return dispatch({type: ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS, Obj: {code: '', message: ''}});
	}
};

export const clearPaymentRequirement = () => {
	return (dispatch) => {
		dispatch({type: ACTION_GET_PAYMENT_REQUIREMENT_STATUS, Obj: {}});
		dispatch({type: ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS, Obj: []});
	}
};



// WEBPACK FOOTER //
// ./src/modules/Configurations/Payments/PaymentRequirement.js